import { useEffect, useState } from "react";
import { SiteModel } from "../models/site.model";
import { useUserContext } from "../../user/contexts/user.context";
import { Sites } from "../../service-worker/sites";

export const useSites = (site: SiteModel | null) => {
  const { currentOrganization } = useUserContext();
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    async function getIsOffline() {
      if (!currentOrganization || !site) {
        setIsOffline(false);
        return;
      }
      const offline = await Sites.isOffline(currentOrganization.code, site.id);
      setIsOffline(offline);
    }
    getIsOffline();
  }, [currentOrganization, site]);

  return isOffline;
};
